import { createColumnHelper } from '@tanstack/react-table'
import { IdEventV4 } from 'models/event'

export const columnHelper = createColumnHelper<IdEventV4>()

export const isBrowser = (original: IdEventV4) => {
  return original.sdk?.platform === 'js'
}

export const isMobile = (original: IdEventV4) => {
  return original.sdk?.platform === 'ios' || original.sdk?.platform === 'android'
}

export const isIos = (original: IdEventV4) => {
  return original.sdk?.platform === 'ios'
}

export const isAndroid = (original: IdEventV4) => {
  return original.sdk?.platform === 'android'
}
